'use client';

import * as React from 'react';
import { ThemeProvider as NextThemesProvider, useTheme } from 'next-themes';

function ThemeSync() {
  const { resolvedTheme } = useTheme();
  React.useEffect(() => {
    document.body.setAttribute('data-lk-theme', resolvedTheme === 'dark' ? 'dark' : 'default');
  }, [resolvedTheme]);
  return null;
}

export function ThemeProvider({ children, ...props }: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider {...props}>
      <ThemeSync />
      {children}
    </NextThemesProvider>
  );
}
